import { useState, useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

export function useSaveAestheticProtocol(patientId) {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback(
    (protocol) => {
      setSaving(true);
      return quarkusApi
        .post(`/patients/${patientId}/aesthetic-protocols`, protocol, {
          headers: { Authorization: sessionStorage.getItem('token') },
        })
        .finally(() => setSaving(false));
    },
    [patientId],
  );

  return { save, isSaving };
}
